import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["firstName", "lastName", "row", "table"];

  swap(event) {
    const row = event.target.closest("tr");
    const firstName = row.querySelector('[data-name-swap-target="firstName"]');
    const lastName = row.querySelector('[data-name-swap-target="lastName"]');
    const temp = firstName.value;
    firstName.value = lastName.value;
    lastName.value = temp;
  }

  swapAll() {
    this.rowTargets.forEach((row) => {
      const firstName = row.querySelector(
        '[data-name-swap-target="firstName"]',
      );
      const lastName = row.querySelector('[data-name-swap-target="lastName"]');
      const temp = firstName.value;
      firstName.value = lastName.value;
      lastName.value = temp;
    });
  }

  remove(event) {
    event.target.closest("tr").remove();
  }
}
